module.exports = __webpack_public_path__ + "static/media/3unit1c.d7eda416.png";